import { motion, useReducedMotion } from "framer-motion";

const phrases = ["DESIGN WITH INTENT", "PRIVACY BY DEFAULT", "MOTION WITH MEANING", "BUILT FOR iPHONE"];

export function Marquee() {
  const reduceMotion = useReducedMotion();
  const items = [...phrases, ...phrases];

  return (
    <div className="marquee" aria-label={phrases.join(", ")}>
      <motion.div
        className="marquee-track"
        aria-hidden="true"
        animate={reduceMotion ? undefined : { x: ["0%", "-50%"] }}
        transition={{ duration: 28, ease: "linear", repeat: Infinity }}
      >
        {items.map((item, index) => (
          <span className="marquee-item" key={`${item}-${index}`}>
            {item}<i />
          </span>
        ))}
      </motion.div>
    </div>
  );
}
